/* import __COLOCATED_TEMPLATE__ from './checkout-link-qr-code-modal.hbs.js'; */
var _dec, _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { action, computed } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@ember/component';
import { buttonClickEvent } from '@dashboard/junk-drawer/utils/eventstream';
function generateQRCodeEvent(label, action, {
  linkType,
  id
}) {
  const metadata = {
    page_click_detail: `${linkType}: ${id}`
  };
  return buttonClickEvent(`${label}: ${action}`, metadata);
}
let CheckoutLinkQrCodeModal = (_dec = computed('qrCodeImageData'), _class = class CheckoutLinkQrCodeModal extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "modal", _descriptor, this);
    _initializerDefineProperty(this, "eventstream", _descriptor2, this);
    _initializerDefineProperty(this, "checkoutLinkSharing", _descriptor3, this);
    _defineProperty(this, "qrCodeImageData", null);
  }
  get qrCodeImageSrc() {
    return `data:image/png;base64, ${this.qrCodeImageData}`;
  }
  click(event) {
    event.stopPropagation();
  }
  async didReceiveAttrs() {
    super.didReceiveAttrs();
    if (this.modalOptions.model) {
      this.set('model', this.modalOptions.model);
      const qrCodeImageData = await this.checkoutLinkSharing.generateQrCode(this.model, 120, 120);
      this.set('qrCodeImageData', qrCodeImageData);
      this.eventstream.track(generateQRCodeEvent(this.modalOptions.eventLabel, 'Show QR Code', this.model));
    }
  }
  close() {}
  downloadQRCode() {
    this.eventstream.track(generateQRCodeEvent(this.modalOptions.eventLabel, 'Download QR Code', this.model));
  }
  cancel() {
    if (this.modal.isOpen) {
      this.close();
    }
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "modal", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "eventstream", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "checkoutLinkSharing", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "qrCodeImageSrc", [_dec], Object.getOwnPropertyDescriptor(_class.prototype, "qrCodeImageSrc"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "downloadQRCode", [action], Object.getOwnPropertyDescriptor(_class.prototype, "downloadQRCode"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "cancel", [action], Object.getOwnPropertyDescriptor(_class.prototype, "cancel"), _class.prototype), _class);
export { CheckoutLinkQrCodeModal as default };